import React, { useEffect, useMemo } from 'react';

import { NativeResources } from '@ariksa/inventory-core';
import { HStack, Stack } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Card, StackedHeader } from 'components/DataDisplay';
import { BorderedBox } from 'components/DataDisplay/Box/BorderedBox';
import { WithSpinner } from 'components/DataDisplay/Spinner/WithSpinner';
import { ActiveResourceProvider } from 'containers/ActiveCloudResource/hooks/context/ActiveResourceProvider';
import { ContainerImages } from 'containers/Visibility/Vulnerabilities/Components/ResourceVulnerabilities/ContainerImages';
import { useResourceVulnerabilities } from 'containers/Visibility/Vulnerabilities/Components/ResourceVulnerabilities/hooks/useResourceVulnerability';
import { ResourceDetails } from 'containers/Visibility/Vulnerabilities/Components/ResourceVulnerabilities/ResourceDetails';
import { getResourceHeaderLabels } from 'containers/Visibility/Vulnerabilities/Components/ResourceVulnerabilities/resourceHeaderUtils';
import { ResourceVulnerabilityActions } from 'containers/Visibility/Vulnerabilities/Components/ResourceVulnerabilities/ResourceVulnerabilityActions';
import { ResourceVulnerabilityDetailsTable } from 'containers/Visibility/Vulnerabilities/Components/ResourceVulnerabilities/ResourceVulnerabilityDetailsTable';
import { selectVulnerabilities } from 'containers/Visibility/Vulnerabilities/selectors';

export const ResourceVulnerabilityPage = () => {
  const { resourceInsight } = useSelector(selectVulnerabilities);
  const { data: insight, isLoading } = resourceInsight;
  const params = useParams<{ id: string }>();
  const { getResourceVulnerabilities } = useResourceVulnerabilities({
    uuid: params.id!,
  });

  const isContainer = useMemo(
    () =>
      [
        NativeResources.Container,
        NativeResources.GcpContainer,
        NativeResources.AzureContainer,
      ].includes(insight?.native_name as any),
    [insight?.native_name],
  );

  useEffect(() => {
    getResourceVulnerabilities();
  }, [getResourceVulnerabilities]);

  /*useEffect(() => {
    if (!params.id) return;
    dispatch(
      actions.getResourceInsight({
        q: {
          insightV2Request: {
            resource_uuids: [params.id],
          },
        },
      }),
    );
    dispatch(
      sharedStateActions.getRiskContext({
        q: {
          riskContextRequest: {
            uuids: [params.id],
          },
        },
      }),
    );
    dispatch(
      actions.getResourceAlertCount({
        q: {
          requestBody: [params.id],
        },
      }),
    );
  }, [params.id, dispatch]);

  useEffect(() => {
    if (isEmpty(insight)) return;
    dispatch(
      sharedStateActions.getSecurityGraphAvailability({
        q: { resources: [insight?.native_name] },
      }),
    );
    dispatch(
      actions.getResourceVulnerabilityCount({
        q: {
          resourceVulnerabilitiesRequest: {
            resource_ids: [insight.uuid],
            native_resource: insight.native_name,
            account_ids: [insight.account],
          },
        },
      }),
    );
  }, [insight, dispatch]);

  useEffect(() => {
    if (isEmpty(insight)) return;
    dispatch(
      actions.getResourceVulnerabilitySummary({
        q: {
          instanceId: isContainer ? undefined : insight.resource_id,
          containerId: isContainer ? insight.resource_id : undefined,
        },
      }),
    );
  }, [insight, dispatch, isContainer]);*/

  return (
    <Card>
      <ActiveResourceProvider>
        <WithSpinner loadStatus={{ loading: isLoading }} spinnerSize="lg">
          <Stack w="full" spacing={5}>
            <HStack w="full">
              <StackedHeader
                // Missing name/type parts are skipped rather than shown as "undefined".
                upper={getResourceHeaderLabels(insight).upper}
                lower={getResourceHeaderLabels(insight).lower}
                type={insight?.native_name}
              />
            </HStack>
            <ResourceVulnerabilityActions />
            <ResourceDetails uuid={params.id!} />
            <BorderedBox flex={1}>
              {insight?.native_name ===
              NativeResources.ElasticContainerRegistry ? (
                <ContainerImages />
              ) : (
                <ResourceVulnerabilityDetailsTable isContainer={isContainer} />
              )}
            </BorderedBox>
          </Stack>
        </WithSpinner>
      </ActiveResourceProvider>
    </Card>
  );
};
